import React from 'react';
import { useTranslation } from 'react-i18next';
import { SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import type { CatalogChannel } from './catalog';

/** Icon, title and subtitle at the top of every integration drawer (the close button is the sheet's). */
export const DrawerHeading: React.FC<{ channel: CatalogChannel }> = ({ channel }) => {
    const { t } = useTranslation('crm');
    const Icon = channel.icon;

    return (
        <SheetHeader className="flex-row items-center gap-3 pe-14">
            <span
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary"
                aria-hidden="true"
            >
                <Icon className="h-5 w-5" />
            </span>
            <div className="min-w-0 space-y-1">
                <SheetTitle>{t(channel.name)}</SheetTitle>
                <SheetDescription>{t(channel.description)}</SheetDescription>
            </div>
        </SheetHeader>
    );
};

export default DrawerHeading;
